import { render, staticRenderFns } from "./TagScanned.vue?vue&type=template&id=e53ed26c&"
import script from "./TagScanned.vue?vue&type=script&lang=js&"
export * from "./TagScanned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports